/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  checkQuarterValidation,
  isCheckDateFormat,
  isOverlapQtr,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { RadioGroupComponent } from '../../Claim/component/SelectClaim/SelectClaimSearchComponent';

import { getRebateProgramCode } from '../../../System/TechnicalWindow/OnlineFixes/CreateStubInvoice/store/action';
import {
  setActionsTypeAction,
  setPlanTypeAction,
  setSelectTypeAction,
  getDrugFamilyCode,
  ProcessDrugFamilyCode,
  setDrugFAMILYProcessResponse,
  setErrorMessage,
} from '../../../System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/store/action';
import { getProviderIdTypeDetails } from '../../Provider/store/action';
import {
  ACTIONS_OPTIONS,
  PLAN_TYPE_DATA_CAL_INS,
  CHOOSE_BY_OPTIONS,
  NDC_TABS_DATA,
} from '../../../System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/utils/constant';
import {
  getAllNDCReferenceData,
  setNDCSelectedNDCTab,
} from '../../NDC/store/action';
import {
  STARTDATE_REQUIRED,
  ENDDATE_REQUIRED,
  SUCCESSMESSAGE_PRICE,
  FAILED_MESSAGE_GENERIC,
  ERRORMESSAGE_NDC_MAN_NOT_EMPTY,
  ERRORMESSAGE_MFR_NOT_EMPTY,
  REBATE_SELECT,
  CHOOSE_BY_REQ,
  ING_MSG,
  DTRNG_MSG,
  NO_VALUE_RESPOSNE_INTEREST,
} from '../../../../SharedModules/Errors/constantMessageData';
import CalculatedInterestNDCTabs from './CalculatedInterestNDCTabs';
// import RequestedPreviousNDCTabs from '../../../System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/components/RequestedPreviousNDCTabs';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

import CalculatedInterestRadioGroup from './CalculatedInterestRadioGroup';
import CalculatedInterestManufacturerTable from './CalculatedInterestManufacturerTable';
import CalculatedInterestQuarters from './CalculatedInterestQuaters';

import {
  calculatedInterestPayload,
  updateCalculatedInterestData,
  calculateUserInputs,
  setSelectedRebateProgram,
  setSelManIdAction,
} from '../store/actions';
import { error } from 'jquery';
import { removeErr } from '../../../../SharedModules/utilities/utilities';
import { QUARTER_FORMAT_ERROR } from '../../../../SharedModules/AppConstants';

const CalculatedInterestHeader = ({
  errorMessages,
  setErrorMessages,
  setLoading,
  setSuccessMessages,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [rebateProgram, setRebateProgram] = React.useState();
  const [rebateData, setRebateData] = React.useState([]);
  const [providerIdList, setProviderIdList] = React.useState([]);
  const [selManId, setSelManId] = React.useState([]);
  const [rbtErr, setRbtErr] = React.useState(false);
  const [paidDateRange, setPaidDateRange] = React.useState({
    paidDateRangeFrom: null,
    paidDateRangeTo: null,
  });
   const GridData = useSelector(
      (state) => state.sharedState.CalculatedInterestReducer.selectedGrid
    );
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [custPayload, setCustPayload] = React.useState();
  const [paidDateRangeError, setPaidDateRangeError] = React.useState({
    paidDateRangeFrom: null,
    paidDateRangeTo: null,
  });
  const [fullScreen, setFullScreen] = React.useState(false);
  const [drugSeqNumSel, setDrugSeqNumSel] = React.useState('');
  const [planType, setPlanType] = React.useState(null);
  const [selectType, setSelectType] = React.useState('NDC');
  const [openModal, setOpenModal] = React.useState(false);
  const [allQtr, setAllQuarters] = React.useState(false);
  const [resetFields, setResetFields] = React.useState(false);
  const [manuTblData, setManuTblData] = React.useState([]);
  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.createStubInvoice?.rebateDropdownData
  );
  const payload = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );
  const ndcDetailsTableRowSelected = useSelector(
    (state) => state.sharedState.ndc.ndcDetailsTableRowSelected
  );
  const labelerDrugTableData = useSelector(
    (state) => state.sharedState.ndc.labelerDrugTableData
  );
  const defaultRebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
   const getAllManufacturerList = useSelector(
      (state) => state.sharedState.CalculatedInterestReducer?.manufacturerList
    );
   const userDefaults = useSelector(
      (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
    );
  const ndcDetailsTableData = useSelector(
    (state) => state.sharedState.ndc.ndcDetailsTableData
  );
  const { calculateduserInputs = {} } = useSelector(
    (state) => state?.sharedState?.CalculatedInterestReducer || {}
  );
  const ndcLoading = useSelector((state) => state.sharedState?.ndc?.loading);
   const selectedData = useSelector(
      (state) => state.sharedState.CalculatedInterestReducer.selectedRebateProgram
    );
  React.useEffect(() => {
    if (GridData && GridData?.length !== 0) {
      setSelManId(GridData);
    }

  }, [GridData]);
  React.useEffect(() => {
    setLoading(ndcLoading);
  }, [ndcLoading]);
    React.useEffect(() => {
      setPlanType(selectedData?.plan);
      setRebateProgram(selectedData?.rebateProgram);
    }, [selectedData]);

  React.useEffect(() => {
    const selRow = labelerDrugTableData?.filter(
      (x) => x.ndc === ndcDetailsTableRowSelected[0]?.ndc
    );
    if (selRow.length > 0) {
      setDrugSeqNumSel(selRow[0].drugSeqNum);
    }
  }, [ndcDetailsTableRowSelected]);
  React.useEffect(() => {
    if (calculateduserInputs.planType) {
      setPlanType(calculateduserInputs?.planType);
      setSelectType(calculateduserInputs?.selectType);
      setRebateData(calculateduserInputs?.rebateData);
      setPaidDateRange(calculateduserInputs?.paidDateRange);
      setAllQuarters(calculateduserInputs?.allQtr);
      setManuTblData(calculateduserInputs?.manuTblData);
    }
  }, [calculateduserInputs]);
  const { actionType, drugFamilyCode, selectedRow, processResponse } =
    useSelector((state) => state?.sharedState?.requestedPreviousClaim || {});

  const handleChangeID = (e) => {
    setErrorMessages([]);
  };
  React.useEffect(() => {
    dispatch(getProviderIdTypeDetails());
  }, []);
  React.useEffect(() => {
    const data = [
      {
        codeDomainKey: null,
        codeValue: null,
        codeValueID: {
          codeDomainKey: 'All',
          codeValue: 'all',
        },
      },
    ];
    if (providerIdList.length > 0) {
      const proIdAllVal = [];
      providerIdList.forEach((item) =>
        proIdAllVal.push(item?.codeValueID?.codeValue)
      );
      providerIdList.unshift(data);
    }
    setProviderIdList(payload);
  }, [payload]);
  React.useEffect(() => {}, [selectedRow]);
  React.useEffect(() => {
    setLoading(false);
  }, [processResponse]);

  React.useEffect(() => {
     if (!selectedData?.plan) {
       setPlanType(userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD');
       setRebateProgram(
         userDefaults?.rebateProgramCd ? userDefaults?.rebateProgramCd : '-1'
       );
 
       dispatch(
         setSelectedRebateProgram({
           plan: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
           rebateProgram: userDefaults?.rebateProgramCd
             ? userDefaults?.rebateProgramCd
             : '-1',
         })
       );
     }
   }, [userDefaults]);
  React.useEffect(() => {
    if (planType) {
      dispatch(getRebateProgramCode(planType));
    }
  }, [planType]);

  const onPlanTypeChange = (type) => {
    setRebateProgram(null);
    setPlanType(type);
  };

  const onSelectTypeChange = async (type) => {
    setSelectType(type);
    dispatch(setSelectTypeAction(type));

    if (type === 'DRUGFAMILY' && rebateProgram != -1) {
      const payload = {
        rebateProgramCode: rebateProgram,
      };
      getDrugFamilyDetails(payload);
    } else if (type === 'MANUFACTURER') {
      if (validateInputs(type, allQtr)) {
        const res = await getManufacturerDetails(rebateProgram, true);
      }
    }
  };

  React.useEffect(() => {
    if (selectType === 'MANUFACTURER' && allQtr) {
      if (validateInputs(selectType, allQtr)) {
        getManufacturerDetails();
      }
    }
    if (allQtr) {
      setResetFields(!resetFields);
      setPaidDateRange();
    }
  }, [allQtr]);

  const getManufacturerDetails = async (rebateCode, check) => {
    if (selectType === 'MANUFACTURER' || check) {
      let payloadman = {};
      if (!allQtr) {
        payloadman = {
          allQtrs: allQtr,
          rebateProgramCd: rebateCode || rebateProgram,
          planTypeCd: 'G',
          startQtr: paidDateRange?.paidDateRangeFrom,
          endQtr:
            paidDateRange?.paidDateRangeTo !== null
              ? paidDateRange?.paidDateRangeTo
              : paidDateRange?.paidDateRangeFrom,
        };
        setLoading(true);
      } else {
        payloadman = {
          allQtrs: allQtr,
          rebateProgramCd: rebateCode || rebateProgram,
          planTypeCd: planType == 'FD' || planType == 'ST' ? 'G' : 'C',
        };
        setLoading(true);
      }
      try {
        if (payloadman.rebateProgramCd != '-1') {
          const response = await axios.post(
            `${serviceEndPoint.CAL_INT_GET_MANUFACTURER}`,
            payloadman
          );

          setLoading(false);
          if (response?.data?.status === 500) {
            setErrorMessages([response?.data?.data]);
          }
          if (!response?.data?.errorMesage){ 
             setManuTblData(response?.data);
          }
        }
      } catch (e) {
        setLoading(false);
        dispatch(setErrorMessage(e));
      }
    }
  };

  React.useEffect(() => {
    setRebateData(rebateDropdownData);
  }, [rebateDropdownData]);

  const validateInputs = (type, checked, isSubmit = false, rpcCode) => {
    const errMsg = [];

    setErrorMessages([]);
    const qtrerr = {
      paidDateRangeFrom: null,
      paidDateRangeTo: null,
    };
    if (!checked && !paidDateRange?.paidDateRangeFrom) {
      errMsg.push(constantMessageData.FROM_QTR_REQUIRED);
      qtrerr.paidDateRangeFrom = true;
    }
    if (!checked && !paidDateRange?.paidDateRangeFrom) {
      errMsg.push(constantMessageData.TO_QTR_REQUIRED);
      qtrerr.paidDateRangeTo = true;
    }
    setPaidDateRangeError({ ...qtrerr });
    setRbtErr(false);
    if (rpcCode != undefined) {
      if (rpcCode == -1 || !rpcCode) {
        errMsg.push(REBATE_SELECT);
        setRbtErr(true);
      }
    } else if (
      rebateProgram == -1 ||
      !rebateProgram ||
      rebateProgram === null
    ) {
      errMsg.push(REBATE_SELECT);
      setRbtErr(true);
    }
    if (
      type === 'NDC' &&
      ndcDetailsTableRowSelected.length === 0 &&
      ndcDetailsTableData.length === 0
    ) {
      errMsg.push(ERRORMESSAGE_NDC_MAN_NOT_EMPTY);
    }
    if (type === 'MANUFACTURER' && selManId.length === 0 && isSubmit === true) {
      errMsg.push(ERRORMESSAGE_MFR_NOT_EMPTY);
    }

    if (errMsg.length > 0) {
      setErrorMessages(errMsg);

      return false;
    }
    return true;
  };
  const convertToFormat = (d) => {
    if (d) {
      const year = d.getFullYear();
      const month = (1 + d.getMonth()).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');

      return `${month}/${day}/${year}`;
    }
  };

  const processData = async () => {
    if (!validateInputs(selectType, allQtr, true)) {
      return;
    }
    const selectedData = {
      planType: planType,
      selectType: selectType,
      rebateData: rebateData,
      paidDateRange: paidDateRange,
      allQtr: allQtr,
      manuTblData: manuTblData,
    };
    dispatch(calculateUserInputs(selectedData));
    if (selectType === 'NDC') {
      let drugSeqNumList = [];
      if (ndcDetailsTableRowSelected.length === 0) {
        drugSeqNumList =
          ndcDetailsTableData?.map((item) => item.drugSeqNum) || [];
      } else {
        drugSeqNumList =
          ndcDetailsTableRowSelected?.map((item) => item.drugSeqNum) || [];
      }

      const payload = {
        planTypeCd: planType,
        chooseBy: selectType,
        drugSeqNumList: drugSeqNumList,
        startQtr: paidDateRange?.paidDateRangeFrom,
        endQtr: paidDateRange?.paidDateRangeTo,
        allQtrs: allQtr,
        rebateProgramCd: rebateProgram,
        byMfg: '0',
      };
      if (drugSeqNumList.length > 1000) {
        setCustPayload(payload);
        setConfirmAction(true);
        return;
      }
      dispatch(calculatedInterestPayload(payload));

      try {
        setLoading(true);
        const response = await axios.post(
          `${serviceEndPoint.VIEW_CALCULATED_INTEREST}`,
          payload
        );
        setLoading(false);
        if (response?.status === 200) {
          dispatch(updateCalculatedInterestData(response?.data));
          if (
            response?.data?.length == 0 ||
            response?.data?.errorCode == '002'
          ) {
            setOpenModal(true);
          } else {
            navigateToPage(
              '/calculated-interest-details',
              'Calculate Interest Details'
            );
          }
        }
      } catch (e) {
        setLoading(false);
        setErrorMessages([]);
        setSuccessMessages([]);
        if (e?.status === 400) {
          setSuccessMessages([e?.data]);
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      }
    } else if (selectType === 'MANUFACTURER') {
      const drugSeqNumList =
        ndcDetailsTableData?.map((item) => item.drugSeqNum) || [];
      const payload = {
        planTypeCd: planType,
        chooseBy: 'mfg',
        drugSeqNumList: drugSeqNumList,
        startQtr: paidDateRange?.paidDateRangeFrom,
        endQtr: paidDateRange?.paidDateRangeTo,
        allQtrs: allQtr,
        rebateProgramCd: rebateProgram,
        byMfg: '1',
        mfgId: selManId,
      };
      dispatch(calculatedInterestPayload(payload));
      try {
        setLoading(true);
        const response = await axios.post(
          `${serviceEndPoint.VIEW_CALCULATED_INTEREST}`,
          payload
        );
        setLoading(false);
        if (response?.status === 200) {
          dispatch(updateCalculatedInterestData(response?.data));
          if (
            response?.data?.length == 0 ||
            response?.data?.errorCode == '002'
          ) {
            setOpenModal(true);
          } else {
            navigateToPage(
              '/calculated-interest-details',
              'Calculate Interest Details'
            );
          }
        }
      } catch (e) {
        setLoading(false);
        setErrorMessages([]);
        setSuccessMessages([]);
        if (e?.status === 400) {
          setSuccessMessages([e?.data]);
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      }
    }
  };
 const onRowSelect = (rowData) => {
    const newObj = manuTblData?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.mfgId === item.mfgId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(setSelManIdAction(newObj));
  };
 
  const rebateProgramChangeHandler = async (e) => {
    const program = e.target?.value;
    dispatch(
      setSelectedRebateProgram({
        plan: planType,
        rebateProgram: e.target.value,
      })
    );
    setRebateProgram(program);
    if (!program) setRbtErr(true);
    else setRbtErr(false);

    if (selectType === 'MANUFACTURER') {
      if (validateInputs(selectType, allQtr, false, program)) {
        await getManufacturerDetails(program);
      }
    }
  };

  const navigateToPage = (pathname, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathname) === -1) {
      updateTabs.push({
        navTo: pathname,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({ pathname });
  };

  const getDrugFamilyDetails = (payload) => {
    dispatch(getDrugFamilyCode(payload));
  };

  const isToDateLessThanFromDate = (fromDate, toDate) => {
    let isInvalidDate = false;
    if (fromDate && toDate) {
      isInvalidDate = Date.parse(fromDate) - Date.parse(toDate) > 0;
    }
    return isInvalidDate;
  };
  const onNDCTypeChange = (type) => {
    dispatch(setNDCSelectedNDCTab(type));
  };
  const handleOnblurEvent = (type, value) => {
    setErrorMessages([]);
    const errMsg = [];
    const errors = { ...paidDateRangeError };
    if (isCheckDateFormat(value)) {
      errors[type] = null;
      let invalidDates = false;

      if (type === 'paidDateRangeFrom') {
        invalidDates = isToDateLessThanFromDate(
          value,
          paidDateRange.paidDateRangeTo
        );
      } else if (type === 'paidDateRangeTo') {
        invalidDates = isToDateLessThanFromDate(
          paidDateRange.paidDateRangeFrom,
          value
        );
      }
      if (invalidDates) {
        if (type === 'paidDateRangeFrom') {
          errors.paidDateRangeTo = null;
          errors[type] = "Start date can't be greater than End date";
        } else if (type === 'paidDateRangeTo') {
          errors.paidDateRangeFrom = null;
          errors[type] = "End date can't be less than Start date";
        }
        if (errors.paidDateRangeTo != null) {
          errMsg.push(errors.paidDateRangeTo);
        }
        if (errors.paidDateRangeFrom != null) {
          errMsg.push(errors.paidDateRangeFrom);
        }
      }
    } else {
      errors[type] = 'Please enter date in MM/DD/YYYY format';
      if (
        errMsg.filter((x) => x == 'Please enter date in MM/DD/YYYY format')
          .length == 0
      ) {
        errMsg.push('Please enter date in MM/DD/YYYY format');
      }
    }
    setPaidDateRangeError(errors);

    setErrorMessages(errMsg);
  };

  const handleOnBlur = (e) => {
    const { name, value } = e.target;
    let newrange = { ...paidDateRange, [name]: value };
    const isValidQuarter = checkQuarterValidation(value);
    if (name === 'paidDateRangeFrom') {
      if (!paidDateRange.paidDateRangeTo && isValidQuarter) {
        newrange = { ...newrange, paidDateRangeTo: value };
        setPaidDateRange(newrange);
      }
    }
    const errors = { ...paidDateRangeError };
    errors[name] = isValidQuarter
      ? null
      : constantMessageData.VALIDATE_QUARTER_VALUE;

    setPaidDateRangeError(errors);

    if (paidDateRange.paidDateRangeTo && paidDateRange.paidDateRangeFrom) {
      const data = {
        startQtr: paidDateRange.paidDateRangeFrom,
        endQtr: paidDateRange.paidDateRangeTo,
      };
      const isOverlap = isOverlapQtr(data, 0, 0);
    }
  };

  const onQuarterRangeErrors = (errors) => {
    if (errors && errors?.length) {
      setErrorMessages([...new Set([...errorMessages, ...errors])]);
    } else if (!errors?.length && errorMessages?.length) {
      const err = removeErr(errorMessages, [
        constantMessageData.FROM_QTR_REQUIRED,
        constantMessageData.TO_QTR_REQUIRED,
        QUARTER_FORMAT_ERROR,
      ]);
      setErrorMessages(err);
    }
  };

  const resetToDefault = () => {
    setPlanType('FD');
    setSelectType('NDC');
    setPaidDateRange({ paidDateRangeFrom: null, paidDateRangeTo: null});
    setAllQuarters(false);
    setResetFields(!resetFields);
    dispatch(setNDCSelectedNDCTab(NDC_TABS_DATA[0].value));
    setRebateProgram(null);
    setErrorMessages([]);
  };

  return (
    <div className="view-calulated-container">
      <>
        {!fullScreen && (
          <>
            <div className="row">
              <div className="col-4 frr-radio-40per-width">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Plan Type <span className="mandatory"> *</span>
                  </legend>

                  <div className="form-wrapper">
                    <RadioGroupComponent
                      data={PLAN_TYPE_DATA_CAL_INS}
                      value={planType}
                      required
                      onChange={(_, value) => {
                        setErrorMessages([]);
                        onPlanTypeChange(value);
                      }}
                    />
                  </div>
                </fieldset>
              </div>
              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Choose By <span className="mandatory"> *</span>
                  </legend>{' '}
                  <div className="p-0 mt-2 row">
                    <div className="mui-custom-form col-12 m-0">
                      <RadioGroupComponent
                        data={CHOOSE_BY_OPTIONS}
                        value={selectType}
                        required
                        onChange={(_, value) => {
                          setErrorMessages([]);
                          onSelectTypeChange(value);
                        }}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Rebate Program
                    <span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="mui-custom-form  with-select w-100 ml-0">
                    <TextField
                      data-testid="rebate_program-generate-inv"
                      id="rebateProgram"
                      label="Rebate Program"
                      fullWidth
                      select
                      required
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'rebateProgram' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={rebateProgram || -1}
                      onChange={rebateProgramChangeHandler}
                      className={`frr-display-hidden-label  ${
                        rbtErr ? 'mandate-fields' : null
                      }`}
                      error={rbtErr}
                      helperText={rbtErr ? REBATE_SELECT : ''}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />

                      {rebateData?.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.value}>
                            {item.label ? `${item.label}` : `${item.value}`}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
              {selectType === 'NDC' ? (
                <div className="col-4">
                  <CalculatedInterestRadioGroup />
                </div>
              ) : null}

              <div className="col-6">
                <fieldset className="custom-fieldset rebate-program">
                  <legend className="same-font-family"> Quarter Range </legend>
                  <div className="row" style={{ marginTop: '-18px' }}>
                    <CalculatedInterestQuarters
                      quarterRange={paidDateRange}
                      resetFields={resetFields}
                      isDisabled={allQtr}
                      required
                      setQuarterRange={setPaidDateRange}
                      onQuarterRangeErrors={onQuarterRangeErrors}
                      getManufacturerDetails={getManufacturerDetails}
                      flderror={paidDateRangeError}
                    />
                    <div
                      className="mui-custom-form with-select input-md"
                      style={{ marginTop: '28px' }}
                    >
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              name="allManufacturers"
                              checked={allQtr}
                              onChange={async (e) => {
                                setAllQuarters(e?.target?.checked);
                                if (
                                  validateInputs(
                                    'All Quarters',
                                    e?.target?.checked
                                  )
                                ) {
                                  if (selectType === 'MANUFACTURER')
                                    await getManufacturerDetails();
                                }
                              }}
                            />
                          }
                          label="All Quarters"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div
              className={`row float-right mt-4 ${
                selectType === 'MANUFACTURER' ? 'btn-group-manu' : ''
              }`}
            >
              <div className="btn-wrapper">
                <div className="mr-5 mt-1 hide-on-print">
                  <Button
                    className="btn-success same-font-family frr-btn-width-17"
                    onClick={processData}
                  >
                    <SVGComponent iconName="Create-new-icon" /> View Calculated
                    Interest
                  </Button>

                  <Button
                    className="btn btn-cancel btn btn-primary frr-btn-width-17"
                    onClick={resetToDefault}
                  >
                    <SVGComponent iconName="Icon-cancel" /> Cancel
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row tables-container" style={{ width: '100%' }}>
          <div className="col-12">
            {selectType === 'NDC' ? (
              <CalculatedInterestNDCTabs
                setErrorMessages={setErrorMessages}
                fullScreen={fullScreen}
                setFullScreen={setFullScreen}
              />
            ) : (
              selectType === 'MANUFACTURER' && (
                <div>
                  <CalculatedInterestManufacturerTable
                    reportData={manuTblData}
                    fullScreen={fullScreen}
                    setFullScreen={setFullScreen}
                    setSelManId={setSelManId}
                    onRowSelect={onRowSelect}
                  />
                </div>
              )
            )}
          </div>
        </div>
      </>

      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={async () => {
          setConfirmAction(false);
          setLoading(true);
          const payload = {
            ...custPayload,
            drugSeqNumList: custPayload.drugSeqNumList.filter(
              (obj, ind) => ind < 1000
            ),
          };
          dispatch(calculatedInterestPayload(payload));
          const response = await axios.post(
            `${serviceEndPoint.VIEW_CALCULATED_INTEREST}`,
            payload
          );
          setLoading(false);
          if (response?.status === 200) {
            dispatch(updateCalculatedInterestData(response?.data));
            if (
              response?.data?.length == 0 ||
              response?.data?.errorCode == '002'
            ) {
              setOpenModal(true);
            } else {
              navigateToPage(
                '/calculated-interest-details',
                'Calculate Interest Details'
              );
            }
          }
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
      />
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="frr-rightAlignment"
        onOk={() => {
          setOpenModal(false);
        }}
        okTitle="OK"
        onClose={() => setOpenModal(false)}
        closeTitle="Cancel"
        modalTitle="View Calculated Interest"
        childrenComponent={
          <div className="p-3">{NO_VALUE_RESPOSNE_INTEREST}</div>
        }
      />
    </div>
  );
};

export default CalculatedInterestHeader;
